export default function ProductBadge({ p, size = "w-12 h-12", ic = "w-6 h-6" }) {
  return (
    <span
      className={`grid place-items-center ${size} rounded-xl shrink-0`}
      style={p.gradient ? { background: p.gradient } : { background: p.tint }}
    >
      <p.Icon className={ic} style={{ color: p.color }} />
    </span>
  );
}
